import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const UmrahCardListSkeleton = () => {
  return (
    <div className={s.container}>
      <div className={s.box}>
        <Skeleton className={s.item} />

        <div className={s.info}>
          <div className={s.header}>
            <Skeleton className={s.item} />
            <Skeleton className={s.item} />
          </div>

          <Skeleton className={s.item} />

          <Skeleton className={s.itemFull} />
        </div>
      </div>

      <div className={s.box}>
        <Skeleton className={s.item} />

        <div className={s.info}>
          <div className={s.header}>
            <Skeleton className={s.item} />
            <Skeleton className={s.item} />
          </div>

          <Skeleton className={s.item} />

          <Skeleton className={s.itemFull} />
        </div>
      </div>
    </div>
  )
}
